export const VALIDATION_CONSTANTS = {
  MIN_NUMBER_LENGTH: 3,
  MAX_NUMBER_LENGTH: 100,
  NUMBER_PATTERN: /^[a-zA-Z0-9._-]+$/
};

export const VALIDATION_MESSAGES = {
  NUMBER_REQUIRED: 'NUMBER_REQUIRED',
  NUMBER_MIN_LENGTH: 'NUMBER_MIN_LENGTH',
  NUMBER_INVALID_CHARACTERS: 'NUMBER_INVALID_CHARACTERS',
  NUMBER_IS_UNIQUE: 'NUMBER_IS_UNIQUE',
  NUMBER_MUST_BE_UNIQUE: 'NUMBER_MUST_BE_UNIQUE',
  ERROR_CHECKING_NUMBER: 'ERROR_CHECKING_NUMBER'
};

export const MODAL_DISMISS_REASONS = {
  CANCEL: 'cancel'
};


// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/admin/create-operating-standard/opst-step-eight/edit-standard-number-popup/constants/validation.constants.ts